<template>
    <div class="wrapper -buscador">
        <div class="encabezado">

            <div class="container column-start">
                <div class="contenedor-logo">
                    <img src="/static/img/UFV-logo.png" alt="Logo UFV">
                </div>
                <h1>Orientación</h1>
                <h2>Buscador de recursos</h2>
            </div>

        </div>

        <div class="migas">
            <div class="container">
                <nav class="row-start">
                    <router-link to="/">Home</router-link>
                    <router-link :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
                    <router-link :to="$t('enlaces.orientacion')">Orientación</router-link>
                    <router-link :to="$t('enlaces.buscadorrecursos')">Buscador de recursos</router-link>
                </nav>
            </div>
        </div>

        <section class="buscador">

            <filtro v-model="filter" :position="3" :orientacion="true" ref="filtro"></filtro>

            <div class="contenedor-resultados container row-start ais" v-if="!!elements && elements.length != 0">

                <template v-for="(el,key) in elements.slice((perpage*page)-perpage,perpage*page)">


                    <div class="noticia">
                        <div class="contenedor-imagen" :style="'background:url('+el.img.url+') center/cover no-repeat'">
                        </div>
                        <h2>{{el.titulo}}</h2>
                        <h3>{{el.fecha.day}} de {{$t(`meses[${el.fecha.month-1}]`)}} {{el.fecha.year}}</h3>
                        <p>{{el.entradilla}}</p>
                        <router-link class="enlace-cover" :to="$t('enlaces.recursos')+'/'+el.slug">
                        </router-link>
                      </div>

                </template>

            </div>

            <p class="zero-results" v-else>No se han encontrado resultados</p>

            <div class="contenedor-paginador row-center" v-if="pages > 1">
                <a @click="prev" class="prev"></a>
                <a :active="n == page" @click="setPage(n)" v-for="n in pages">{{n}}</a>
                <a @click="next" class="next"></a>
            </div>

        </section>

    </div>
</template>

<script>

    import filtro from '@/components/parts/filtro'

    import { mapGetters } from 'vuex';

    export default {
        name: 'buscador-recursos',
        data: () => ({
            page: 1,
            filter : ''
        }),
        methods: {
            prev() {
                if (this.page > 1) {
                    this.page--;
                }
            },
            next() {
                if (this.page < this.pages) {
                    this.page++;
                }
            },
            setPage(page) {
                this.page = page;
            },
            clickForm(value) {
                $('html,body').animate({ scrollTop: $(".filtro").offset().top - 100 }, 500, 'swing');
                this.$refs.filtro.setArea(value);
            }
        },
        computed: {
            ...mapGetters({
                recursos: 'getRecursosOrientacion'
            }),
            elements() {

                let elements = new Array();

                if (!!this.filter) {

                    elements = this.recursos;
                    //AREAS
                    if (!!this.filter.area) {
                        elements = elements.filter(e => (e.area.some(a => a.slug == this.filter.area)));
                    }

                    if (!!this.filter.categoria) {
                        elements = elements.filter(e => (e.categoria.some(a => a.slug == this.filter.categoria)));
                    }

                    if (!!this.filter.titulos) {
                        elements = elements.filter(e => (e.titulos.some(a => a.slug == this.filter.titulos.slug)));
                    }

                    if (!!this.filter.tags) {
                        elements = elements.filter(e => {
                            let existe = false;

                            if (!!e.tags) {
                                e.tags.forEach(t => {
                                    (this.filter.tags.some(tag => tag == t)) ? existe = true : null;
                                })
                            }

                            return existe;

                        });
                    }

                    if (!!this.filter.search) {

                        let searchIn = ['titulo', 'entradilla'];

                        elements = elements.filter(element => {

                            let can = false;

                            searchIn.forEach(where => {
                                (element[where].toLowerCase().includes(this.filter.search.toLowerCase())) ? can = true : '';
                            });

                            return (can) ? element : '';
                        });

                    }

                    if (!!this.filter.fecha) {
                        let actual = new Date().getTime();
                        const SEMANAVAL = 604800000;
                        let limit;
                        switch (this.filter.fecha) {
                            case 'day':
                                limit = (actual - SEMANAVAL);
                                break;
                            case 'month':
                                limit = (actual - SEMANAVAL * 4);
                                break;
                            case 'ever':
                                limit = 0;
                                break;
                        }

                        elements = elements.filter(o => {
                            let fecha = new Date(o.fecha.full).getTime();
                            return (fecha >= limit);
                        });


                    }

                } else {
                    elements = this.recursos;
                }

                return elements;
            },
            perpage() {
                return 9;
            },
            pages() {
                return Math.ceil(this.elements.length / this.perpage);
            }
        },
        components: {
            'filtro': filtro,
        },
        filters: {
            stringcategoria(value) {
                if (value.length > 1) {

                    let cats = new Array();
                    value.forEach(v => {
                        cats.push(v.nombre);
                    })
                    let last = cats.pop();
                    return cats.join(", ") + ' y ' + last;
                } else {
                    return value[0].nombre
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    .evento .contenedor-imagen::before{
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/buscador-recursos.vue